/* eslint-disable */
import React from "react";
import cn from "classnames";
import { TreeView, TreeItem, Skeleton } from "@material-ui/lab";
import { useStylesTreeView, useStylesTreeitem } from "./styles";
import { useHierarchicalSelector } from "./useHierarchicalSelector";
import Input from "./Input";
import Search from "./Search";
import Popover from "./Popover";
import AddBoxOutlinedIcon from "../../../../icons/OpenTree";
import { cloneDeep } from "lodash";
import RemoveOutlinedIcon from "../../../../icons/CloseTree";
import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { hierarchiesFindChild, hierarchies, Hierarchy } from "../../../bulkexport";
import { useDictionary, useParameter } from "../../shared";
import { dictionaryService } from "../../dataFlow";

const useParentStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    selected: {
      "& $content": {
        background: "none !important",
      },
      "& $label": {
        background: "none !important",
      },
    },
    content: {
      borderRadius: "4px",
      padding: "6px",
      height: "32px",
    },
    label: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
    },
  })
);

const useItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: "2px",
      "& $content:hover": {
        background: "rgba(51, 51, 51, 0.05)",
      },
    },
    content: {
      borderRadius: "4px",
      padding: "6px",
      height: "32px",
    },
    label: {
      color: "rgba(39, 58, 57, 0.8)",
      fontSize: "12px",
      lineHeight: "100%",
      fontWeight: "bold",
      background: "none !important",
    },
    selected: {
      "& $content": {
        background: "rgba(101, 172, 30, 0.2)",
      },
      "& $label": {
        background: "none !important",
        color: "#65AC1E",
      },
    },
  })
);

export const BusinessUnit: React.FC<any> = (props) => {
  const [items, setItems] = React.useState<any>(props.items || []);
  const [param, setParam] = useParameter("@business-units");
  const [dictItems, dict] = useDictionary(dictionaryService, "slides-business-unit");
  const { search, handleSearch } = useHierarchicalSelector();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classesItem = useItemStyles();
  const classesParent = useParentStyles();

  const [checked, setChecked] = React.useState<number>(param as any);
  React.useEffect(() => {
    if (dictItems) {
      const nextItems = dictItems.map<any>((x) => ({
        id: String(x.id),
        name: (x.getValue("name") as any)[9] as string,
        parent: undefined,
      }));
      setItems(nextItems);
    }
  }, [dictItems]);

  React.useEffect(() => {
    if (param !== checked) {
      setChecked(param as any);
    }
  }, [param, checked]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const treeViewClasses = useStylesTreeView(props);
  const nodes = React.useMemo(
    () =>
      hierarchies<any>(
        items.filter((x) => !search || x.name.trim().toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())),
        "id",
        "parent"
      ),
    [items, search]
  );
  const open = Boolean(anchorEl);
  const togglePopover = (e) => (open ? handleClose() : handleClick(e));
  const itemClasses = useStylesTreeitem(props);
  const showSoybean = "soybean".includes(search);
  const handleToggle = (e, value) => {
    for (const id of value) {
      const node = hierarchiesFindChild(nodes, id);
      if (!Boolean(node?.children.length)) {
        setChecked(Number(id));
        setParam(Number(id));
        handleClose();
      }
    }
  };

  const customNode = (hierarchy: Hierarchy<any>) => {
    if (hierarchy.children.length) {
      return (
        <TreeItem role="listitem" key={hierarchy.item.name} nodeId={hierarchy.id} label={hierarchy.item.name} classes={classesParent}>
          {hierarchy.children.map(customNode)}
        </TreeItem>
      );
    }
    return <TreeItem role="listitem" key={hierarchy.item.name} nodeId={hierarchy.id} label={hierarchy.item.name} classes={classesItem} />;
  };

  const inputValue = (items && items.find((x) => x.id === String(checked))?.name) || "";
  if (!nodes?.length) {
    return <Skeleton variant="rect" width="168px" height="51px" />;
  }
  return (
    <>
      <Input label="Business unit" value={inputValue} open={open} onClick={togglePopover} />
      <Popover anchorEl={anchorEl} onClose={togglePopover}>
        <Search onChange={handleSearch} />
        {
          <TreeView
            defaultCollapseIcon={<RemoveOutlinedIcon />}
            defaultExpandIcon={<AddBoxOutlinedIcon />}
            role="list"
            defaultExpanded={nodes.map((x) => x.id)}
            // expanded={Boolean(props.search) ? nodes.map(x => x.id) : undefined}
            selected={[String(checked)]}
            multiSelect
            onNodeSelect={handleToggle}
          >
            {!nodes?.length && "" ? "No results" : null}
            {nodes.map(customNode)}
          </TreeView>
        }
      </Popover>
    </>
  );
};
